export const Constants = {
  'VOTE_SUMMARY_PAGE': 'voteSummaryPage',
  'VOTING_PAGE': 'votingPage',
  'CANDIDATE_STATEMENT_PAGE': 'candidateStatementPage',
  'START_VOTING_PAGE': 'startVoting',
  'HELP_PAGE': 'helpPage',
  "CANDIDATE_KEY": 'candidate_key'
}



// WEBPACK FOOTER //
// ./src/app/constant.ts